export default "/static/dashboard/build/app/img/v2/b55167c799415c43b8e392f664944b14.png";